// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"dedb1f5b","608":"568b3dcb","668":"53a6dfb0","768":"5f023ce9"}[chunkId] + ".chunk.css";
};